/*jshint esversion: 6 */

function FeaturedLinksToHamburgerToggle() {
    var menu = document.querySelector('.reshape-splash-menu ul');
    var nav = document.querySelector('.site-nav .mega-menu');

    if (nav && menu) {
        nav.innerHTML += menu.innerHTML
    }
}
document.addEventListener('DOMContentLoaded', function () {
    FeaturedLinksToHamburgerToggle();
});
